<template>
  <v-container fluid>
    <v-btn
      :to="{ name: 'admin.index' }"
      elevation="0"
      tile
      icon
    >
      <v-icon size="20">mdi-arrow-left</v-icon>
    </v-btn>

    <v-divider class="mb-3 mt-1"></v-divider>

    <v-row>
      <v-dialog v-model="modal" max-width="600">
        <v-card>
          <v-card-title>Create User</v-card-title>

          <v-card-text>
            <v-form>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="user.firstName"
                    label="First Name"
                    solo
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="user.lastName"
                    label="Last Name"
                    solo
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="user.email"
                    label="Email"
                    solo
                    dense
                  ></v-text-field>
                </v-col>

                <v-col cols="12" class="text-right">
                  <v-btn
                    @click="submit"
                    :disabled="disabled"
                    type="submit"
                    color="primary"
                    small
                  >Save</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>

        <template v-slot:activator="{ on }">
          <v-col cols="12" class="text-right d-flex align-center justify-end">
            <v-btn
              @click="on.click"
              color="primary"
              fab
              x-small
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </template>
      </v-dialog>
    </v-row>

    <v-row fluid>
      <v-col cols="12">
        <v-simple-table>
          <template>
            <thead>
              <tr>
                <th class="text-no-wrap">First Name</th>
                <th class="text-no-wrap">Last Name</th>
                <th class="text-no-wrap">Email</th>
                <th class="text-no-wrap text-right">Actions</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="u in users" :key="u.guid">
                <td class="text-no-wrap" :title="u.firstName">{{ u.firstName }}</td>
                <td class="text-no-wrap" :title="u.lastName">{{ u.lastName }}</td>
                <td class="text-no-wrap" :title="u.email">{{ u.email }}</td>
                <td class="text-no-wrap text-right">
                  <app-delete :item="u" :fields="['email']" @confirm="remove(u)">
                    <template v-slot="{ on }">
                      <v-btn tile icon v-on="on">
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                  </app-delete>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { User } from '@/api';

export default {
  name: 'app-admin-users',
  data() {
    return {
      disabled: false,
      modal: false,
      users: [],
      user: {},
    };
  },
  methods: {
    // open(on) {
    //   on.click();
    // },
    close() {
      this.modal = false;
      this.disabled = false;
    },
    async remove(user) {
      await User.delete(user.guid);
      await this.fetch();
    },
    async fetch() {
      this.$store.commit('START_LOADING');

      try {
        this.users = (await User.fetch()).data;
      } catch (err) {
        console.error();
      }

      this.$store.commit('END_LOADING');
    },
    async submit(e) {
      e.preventDefault();
      this.disabled = true;

      try {
        await User.create(this.user);
      } catch (err) {
        console.debug('ERROR', err);
      }

      await this.fetch();
      this.close();
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
